import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { CourseTab } from '../menuTab';
import { HaveImage, Paragraph } from '../../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../../layoutPages/defaultSetting';
import { DottedList } from '../../../layoutPages/containers/DottedList';
import { MainCard } from '../../../layoutPages/components/MainCard';
import ChangeHistoryTwoToneIcon from '@mui/icons-material/ChangeHistoryTwoTone';
import StarsIcon from '@mui/icons-material/Stars';
import { mathMenuData } from '../../../data/SubjectMenu/mathMenuData';

export function PageMathsConcern() {

    const isPc = useMediaQuery('(min-width:600px)');

    let dottedListData = [
        "透過慶祝3月14 日「國際數學日」（Pi Day），設計各種與π相關的遊戲和競賽，豐富學生多元學習經歷。活動滲入中華文化元素，提升學習數學的興趣和熱愛，營造愉快的學習數學氛圍。"
    ];

    let dottedListData2 = [
        "優化數學科小一數學繪本教學，拓展校本繪本教學策略。",
        "選取合適的課題，透過課堂教學或課後延伸滲入中國數學歷史的知識，擴闊「家國情懷」之情。",
        "透過「國際數學日」(3月14日)，與圖書館合作。善用多元閱讀資源，舉辦主題式閱讀活動，以推動同學對中國數學家與西方數學歷史文化的認識，從中擴闊視野及享受閱讀的樂趣。"
    ]

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='數學科 | 年度重點項目' size='h3' subtitle={{ title: 'CURRENT MAIN CONCERN', size: 'h5' }} />
            <Grid item xs={11} sm={10}>
                <CourseTab data={mathMenuData}/>
                <MainCard src="http://www.pkps.edu.hk/img/teachplan/maths/concern/top.jpg" noImgPopup={true} />
            </Grid>

            <Grid item xs={11} sm={10} sx={{ p: 2 }}>

            <Typography variant="h4" align={"left"} sx={{ pt: 2, color: "#F02602" }} >1.	配合學校關注事項，拓展跨學科學習；持續發展校本數學科STEAM課程，誘發學生對科探的好奇、探索和學習動機。</Typography>
            <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["數學課程除了着重在不同情境中應用數學，將適切地滲入科學和科技元素。","以小一﹑小三﹑小四及小六作試點，選取合適的課題循序漸進地加入編程元素(如SCRATCH或MICROBIT等)或科學元素進行教學，拓展能讓學生有機會探索科學原理和擴展創造力的STEAM學習活動或有趣的試後活動。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/2425-1.jpg" },
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/2425-2.jpg" },
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/3.jpg" },
                        ],
                        
                        position: "down",
                    }}
                />

            <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["繼續探索與不同學科合作的可能，促使學生靈活連貫各個學習領域，提昇學生綜合應用所學的能力。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/4.jpg" },
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/5.png" }
                        ],    
                        position: "down",
                        imageHeight:"450px",
                    }}
                    sx={{mb:3}}
                />

<Typography variant="h4" align={"left"} sx={{ pt: 5, color: "#F02602" }} >2.    以中華優秀傳統文化融入校本數學教學，欣賞中國古人的智慧。</Typography>

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={dottedListData} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/2425-5.jpg" }
                        ],

                        position: "down",
                    }}
                />

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["落實素養課堂，選取各級合適的單元課題，在課堂設計﹑課後延伸或試後活動中，滲透中華文化元素相關內容，讓學生欣賞中國古人的智慧及中華文化。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/2425-6.png" },
                            { src: "http://www.pkps.edu.hk/img/teachplan/maths/concern/2425-7.jpg" }
                        ],

                        position: "down",
                        imageHeight:"550px",
                        
                    }}
                />

                
               <Typography variant="h4" align={"left"} sx={{ pt: 2, color: "#F02602" }} >3. 發展應用題教學，提升思維能力。</Typography>
               <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["發展小一應用題教學。引入以數棒或圖畫簡化問題的圖解法，加強學生理解及分析題目的能力，幫助學生輕鬆解題和掌握數學概念。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                />
            </Grid>




        </Grid>
    )
}
